import { render, staticRenderFns } from "./turn-over.vue?vue&type=template&id=12ca1600&scoped=true"
import script from "./turn-over.vue?vue&type=script&lang=js"
export * from "./turn-over.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca1600",
  null
  
)

export default component.exports